var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_11772)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1909_11772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9868 26.4981C43.6271 26.4981 46.8184 31.7477 46.8184 36.2403C46.8184 40.7328 43.6271 45.9825 36.9868 45.9825C30.3439 45.9825 27.1553 40.7328 27.1553 36.2403C27.1553 31.7477 30.3439 26.4981 36.9868 26.4981ZM36.9868 40.8643C39.3527 40.8643 41.3585 38.9164 41.3585 36.2403C41.3585 33.5642 39.3527 31.6163 36.9868 31.6163C34.6209 31.6163 32.6126 33.5642 32.6126 36.2403C32.6126 38.9164 34.6209 40.8669 36.9868 40.8669M49.9019 21.0303H55.4329V45.4725H49.9019V21.0303ZM62.0416 38.2934C61.559 38.2937 61.0811 38.3891 60.6354 38.5741C60.1897 38.7591 59.7847 39.0301 59.4437 39.3716C58.755 40.0613 58.3685 40.9963 58.3692 41.971C58.3699 42.9457 58.7577 43.8801 59.4474 44.5689C60.1371 45.2576 61.0722 45.6441 62.0468 45.6434C63.0215 45.6427 63.956 45.2548 64.6447 44.5651C65.3334 43.8754 65.7199 42.9404 65.7192 41.9657C65.7185 40.9911 65.3307 40.0566 64.641 39.3679C63.9513 38.6792 63.0162 38.2927 62.0416 38.2934ZM17.1817 21.0303H12.2554L2.62891 45.4672H9.15349L10.4416 41.9368H18.9325L20.1207 45.4672H26.7084L17.1817 21.0303ZM12.1608 36.9816L14.7212 28.4592L17.2816 36.9816H12.1608Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_11772",
    x: -77.3711,
    y: -58.9697,
    width: 223.09,
    height: 184.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_11772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_11772",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_11772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAol);
export default __webpack_public_path__ + "static/media/icon-aol.9199b90fc68020468d5bf16d8d775e9f.svg";
export { ForwardRef as ReactComponent };